import {useId} from 'react';
import {useTranslation} from 'react-i18next';
import {cn} from '@chekinapp/ui';
import {
  RAIL_VARIANTS,
  VELA_RAIL_CONTENT_REVEAL,
  RailToggle,
} from 'components/CollapsibleRail';
import type {CollapsibleRailState} from 'hooks/useCollapsibleRail';
import {type VelaResult} from '../hooks/useVela';
import {VelaCollapsedStrip} from './VelaCollapsedStrip';
import {VelaPanelBody} from './VelaPanelBody';

type Props = {
  vela: VelaResult;
  rail: CollapsibleRailState;
};

function VelaPanel({vela, rail}: Props) {
  const {t} = useTranslation('vela');
  const {t: tCommon} = useTranslation();
  const contentId = useId();

  return (
    <>
      {!rail.isOpen && (
        <VelaCollapsedStrip
          label={t('name')}
          expandLabel={tCommon('expand_panel')}
          onExpand={rail.toggle}
          controls={contentId}
          animate={rail.hasToggled}
        />
      )}

      <div
        className={cn(
          'sticky top-[var(--maintenance-banner-height,0px)] hidden h-[var(--app-dvh,100dvh)] overflow-hidden vela:block',
          !rail.isOpen && RAIL_VARIANTS.vela.foldedContent,
          rail.isOpen && rail.hasToggled && VELA_RAIL_CONTENT_REVEAL,
        )}
      >
        {rail.isOpen && (
          <RailToggle
            isOpen
            onToggle={rail.toggle}
            expandLabel={tCommon('expand_panel')}
            collapseLabel={tCommon('collapse_panel')}
            rail="vela"
            controls={contentId}
            className="absolute right-3 top-[22px] z-10 bg-[var(--assistant-panel-bg)]"
          />
        )}

        <VelaPanelBody
          id={contentId}
          vela={vela}
          stickyHeader
          fitEnabled={rail.isOpen}
          className="h-full min-w-[var(--assistant-rail-width)] overflow-hidden"
        />
      </div>
    </>
  );
}

export {VelaPanel};
